import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KpiResultPeriodFieldHistoryItem } from '@masar/common/models';

@Component({
    selector: 'app-period-field-history-table',
    templateUrl: './period-field-history-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PeriodFieldHistoryTableComponent {
    @Input() public items: KpiResultPeriodFieldHistoryItem[] = [];

    @Input() public type: 'result-analysis' | 'improvement-procedure' =
        'result-analysis';

    public trackByIndex(index: number): number {
        return index;
    }
}
